import React from 'react'
import Photo from '../../assets/Images/Photo.png'

const styles = {
    maxWidth: '300px',
}

const Image = () => {
    return (
        <div>
            <img style={styles} src={Photo} alt="MyPhoto" />
        </div>
    )
}


export default Image
